import { ARC_DATA } from '../lib/arcData.js';

// 사건이 왜 나왔는지 한 줄과, 접어 둔 근거(책·위치·검수 상태). 이유가 없으면 아무것도 그리지 않는다.
export default function WhyLine({ why }) {
  if (!why?.text) return null;
  const cards = (why.cardIds ?? []).map((id) => ({ id, ...ARC_DATA.cards?.[id] })).filter((card) => card.book);
  return <div className="event-why">
    <p className="event-context">{why.text}</p>
    <details className="event-why-basis">
      <summary>근거 보기</summary>
      <ul>{cards.map((card) => <li key={card.id}>{card.book} {card.locator} · {card.verified ? '검수됨' : '초안(원문 확인 전)'}</li>)}</ul>
      {why.tier === 'game' && <p className="muted small">전환 유형 분류는 게임 규칙으로 정한 것이고 고서의 수치 공식이 아니에요.</p>}
    </details>
  </div>;
}
